import React, { useState } from 'react';
import EmailOverview from '../components/EmailAdmin/EmailOverview';
import DripEmailList from '../components/EmailAdmin/DripEmailList';
import WeeklyReminderPreview from '../components/EmailAdmin/WeeklyReminderPreview';
import UnsubscribedUsers from '../components/EmailAdmin/UnsubscribedUsers';

const tabs = [
    { key: 'overview', label: 'Overview' },
    { key: 'drip', label: 'Drip Emails' },
    { key: 'weekly', label: 'Weekly Reminder' },
    { key: 'subscribers', label: 'Subscribers' },
];

const tabStyle = (isActive) => ({
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: isActive ? 600 : 400,
    color: isActive ? '#0884a8' : '#666',
    background: 'none',
    border: 'none',
    borderBottom: isActive ? '2px solid #0884a8' : '2px solid transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'color 0.15s, border-color 0.15s',
});

const EmailAdminPage = () => {
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <div style={{ padding: '20px' }}>
            <h1 style={{ fontFamily: '"Montserrat", sans-serif', color: '#2c3e50', fontSize: '28px', fontWeight: 700, marginBottom: '24px' }}>
                Email Management
            </h1>
            <div style={{ display: 'flex', gap: '4px', borderBottom: '1px solid #e0e0e0', marginBottom: '24px' }}>
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        style={tabStyle(activeTab === tab.key)}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div>
                {activeTab === 'overview' && <EmailOverview />}
                {activeTab === 'drip' && <DripEmailList />}
                {activeTab === 'weekly' && <WeeklyReminderPreview />}
                {activeTab === 'subscribers' && <UnsubscribedUsers />}
            </div>
        </div>
    );
};

export default EmailAdminPage;
